export { BeeBackButtonModule } from './bee-back-button.module';
export { BeeBackButtonComponent } from './bee-back-button.component';
